import React from 'react';
import AllocatedFW from './Rpt_Allocated_FeeWaiver';
import '../../../CommonCSS/SocietyCSS.css'

const RptAllocatedFWApp = () => {
  return (

    <div className="app-wrapper">
      <div className="form-container">
        <div className='card' style={{borderRadius: '8px'}}>
          <div className="card-header-css" style={{borderRadius: '8px', textAlign: 'center' }} >
            <h5>Allocated Fee Waiver</h5>
          </div>
        </div>
        <AllocatedFW />
      </div>
    </div >
  );
};

export default RptAllocatedFWApp;
